/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable object-curly-newline */
import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Archive } from 'lucide-react';
import './settings.css';
import DataTable from '../../components/DataTable';
import RowActionMenu from '../../components/RowActionMenu';
import { sendRequest } from '../../api/shootAPI';
import API from '../../api/endpoints';
import { UserContext } from '../../contexts/User';
import { AccrualSchedule } from '../../constants/offTimePolicy';
import { NotificationContext } from '../../contexts/Notification';
import TimeOffPolicyModal from './TimeOffPolicyModal';
import TimeOffTabPageHeader from './TabPageHeader';
import DeleteModal from './DeleteModal';
import ArchiveModal from './ArchiveModal';

function TimeoffActivePanel({ getPolicies, isLoading, policies }) {
  const { activeWorkspace } = useContext(UserContext);
  const { displayNotification } = useContext(NotificationContext);
  const [showNewModal, setShowNewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [teams, setTeams] = useState([]);
  const [members, setMembers] = useState([]);
  const [selectedPolicy, setSelectedPolicy] = useState();

  const archiveOffTimePolicy = async (id) => {
    const res = await sendRequest({ method: 'put', url: API.WORKSPACE.archiveOffTimePolicy(activeWorkspace.id, id) });
    if (res.success) {
      setShowArchiveModal(false);
      displayNotification({ message: 'Policy has been archived successfully.', severity: 'success' });
      getPolicies();
    } else {
      displayNotification({ message: 'An error occurs while archiving a PTO policy.', severity: 'error' });
    }
  };

  const deleteOffTimePolicy = async (id) => {
    const res = await sendRequest({ method: 'delete', url: API.WORKSPACE.deleteOffTimePolicy(activeWorkspace.id, id) });
    if (res.success) {
      setShowDeleteModal(false);
      displayNotification({ message: 'Policy has been deleted successfully.', severity: 'success' });
      getPolicies();
    } else {
      displayNotification({ message: 'An error occurs while removing a PTO policy.', severity: 'error' });
    }
  };

  const getTeams = async () => {
    const res = await sendRequest({ method: 'get', url: API.WORKSPACE.getTeams(activeWorkspace.id) });
    if (res.success) setTeams(res.data.teams);
    else displayNotification({ message: 'An error occurs while fetching teams.', severity: 'error' });
  };

  const getMembers = async () => {
    const res = await sendRequest({ method: 'get', url: API.WORKSPACE.members(activeWorkspace.id), params: { pageSize: 0 } });
    if (res.success) {
      const membersArr = res.data.members.map((member) => ({
        id: member.id,
        name: member?.user?.firstName && member?.user?.lastName ? `${member.user.firstName} ${member.user.lastName}` : member.user.email,
      }));
      setMembers(membersArr);
    } else {
      displayNotification({ message: 'An error occurs while fetching teams.', severity: 'error' });
    }
  };

  useEffect(() => {
    getPolicies();
    getTeams();
    getMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const rows = (policies || []).filter((p) => !p.isArchived);

  const columns = [
    { key: 'name', label: 'Policy Name', sortable: true, width: 240, flex: true, render: (p) => <span className="font-medium text-ink-900">{p.name}</span> },
    { key: 'members', label: 'Members', sortable: true, width: 110, render: (p) => <span className="tabular-nums text-ink-700">{p.members.length}</span> },
    { key: 'teams', label: 'Teams', sortable: true, width: 100, render: (p) => <span className="tabular-nums text-ink-700">{p.teams.length}</span> },
    { key: 'accrual', label: 'Accrual Schedule', sortable: true, width: 180, render: (p) => <span className="text-ink-700">{AccrualSchedule[p.scheduleOfAccrual]?.text}</span> },
    {
      key: 'action',
      label: '',
      width: 72,
      align: 'center',
      render: (p) => (
        <RowActionMenu
          ariaLabel={`Actions for ${p.name}`}
          items={[
            { label: 'Edit Policy', onClick: () => { setSelectedPolicy(p); setShowEditModal(true); } },
            { label: 'Archive Policy', onClick: () => { setSelectedPolicy(p); setShowArchiveModal(true); } },
            { label: 'Delete Policy', destructive: true, onClick: () => { setSelectedPolicy(p); setShowDeleteModal(true); } },
          ]}
        />
      ),
    },
  ];

  return (
    <>
      {showNewModal && <TimeOffPolicyModal closeModal={() => setShowNewModal(false)} getPolicies={getPolicies} teams={teams} members={members} />}
      {showEditModal && <TimeOffPolicyModal policy={selectedPolicy} closeModal={() => setShowEditModal(false)} getPolicies={getPolicies} teams={teams} members={members} />}
      {showDeleteModal && (
        <DeleteModal policyName={selectedPolicy.name} setShowModal={setShowDeleteModal} callback={() => deleteOffTimePolicy(selectedPolicy.id)} type="policy" />
      )}
      {showArchiveModal && (
        <ArchiveModal
          tone="brand"
          icon={<Archive size={24} />}
          title="Archive this policy?"
          description="Archived policies stop accruing and can be restored later from the Archived tab."
          policyName={selectedPolicy.name}
          setShowModal={setShowArchiveModal}
          callback={() => archiveOffTimePolicy(selectedPolicy.id)}
          buttonName="Archive"
        />
      )}
      <TimeOffTabPageHeader title="Time off policies" subtitle="Set up automatic accrual policies for time off" buttonName="Add Policy" onClickBtn={() => setShowNewModal(true)} />
      <DataTable bare columns={columns} rows={rows} getRowKey={(p) => p.id} loading={isLoading} emptyText="No active policies yet." minWidth={760} />
    </>
  );
}

TimeoffActivePanel.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  policies: PropTypes.array,
  getPolicies: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

TimeoffActivePanel.defaultProps = { policies: [] };

export default TimeoffActivePanel;
